import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

type Props = {
  showEmptyHelp?: boolean;
  emptyText?: string;
};

const MessageEmptyData = ({ emptyText, showEmptyHelp }: Props) => {
  return (
    <Box
      display="flex"
      height="100%"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      color="text/secondary"
    >
      <Text textStyle="body/md/regular">No data to display with the selected filters.</Text>
      {showEmptyHelp && (
        <Text textStyle="body/md/regular">{emptyText || 'Try adjusting the date range and filters.'}</Text>
      )}
    </Box>
  );
};

export default MessageEmptyData;
